import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, isRef as _isRef, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "drawer-content user-form" }
const _hoisted_2 = { class: "buttons" }
const _hoisted_3 = ["disabled"]

import { onMounted, PropType, reactive } from 'vue';
import { useStore } from 'vuex';
import useVuelidate from '@vuelidate/core';
import { User, userValidations } from '@/models/user';
import Field from '@/components/common/Field.vue';
import UserFields from '@/components/user/UserFields.vue';
import { useLoading } from '../common/loading.composable';
import { Actions } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileForm',
  props: {
  data: {
    type: Object as PropType<User>,
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const store = useStore();



const emit = __emit;

const { loading, setLoading } = useLoading();
let profile = reactive<User>({ ...store.state.profile });
const $v = useVuelidate(userValidations, profile);

onMounted(async () => {
  await store.dispatch(Actions.GetProfile);
});

const submit = async () => {
  setLoading(true);
  await store.dispatch(Actions.UpdateProfile, profile);
  setLoading(false);
  cancel();
};

const cancel = () => {
  emit('close');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_unref(profile))
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _withModifiers(submit, ["prevent"]),
          class: _normalizeClass({ submitting: _unref(loading) })
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Edit your profile", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("p", null, "Edit the details of your profile", -1)),
          _createVNode(Field, {
            label: "Email",
            readonly: "",
            validation: _unref($v).email,
            modelValue: _unref(profile).email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(profile).email) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(UserFields, {
            modelValue: _unref(profile),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(profile) ? (profile).value = $event : profile = $event)),
            validation: _unref($v),
            loading: _unref(loading)
          }, null, 8, ["modelValue", "validation", "loading"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "confirm",
              type: "submit",
              disabled: _unref(loading)
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("span", { class: "icon icon-pencil" }, null, -1),
              _createElementVNode("span", { class: "text" }, "Edit", -1)
            ]))], 8, _hoisted_3),
            _createElementVNode("button", {
              class: "cancel",
              type: "button",
              onClick: cancel
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("span", { class: "text" }, "Cancel", -1)
            ]))])
          ])
        ], 34))
      : _createCommentVNode("", true)
  ]))
}
}

})